"use client";

/**
 * Renders a product image. If the product opts in via `responsiveImages[filename]`,
 * outputs a <picture> with webp + fallback srcsets generated by imagemagick
 * (e.g. `<base>-480w.webp`, `<base>-480w.jpg`, ... following `<base>-<width>w.<ext>`).
 * Otherwise falls back to a plain <img> — letting products opt in one at a time.
 */
export default function ProductImage({ product, filename, alt, ...imgProps }) {
  const responsive = product.responsiveImages?.[filename];
  const src = `/images/products/${filename}`;

  if (!responsive) {
    return <img src={src} alt={alt} {...imgProps} />;
  }

  const dot = filename.lastIndexOf(".");
  const base = filename.slice(0, dot);
  const ext = filename.slice(dot + 1);
  const { widths, sizes } = responsive;

  const srcSet = (format) =>
    widths.map((w) => `/images/products/${base}-${w}w.${format} ${w}w`).join(", ");

  return (
    <picture>
      <source type="image/webp" srcSet={srcSet("webp")} sizes={sizes} />
      <img src={src} srcSet={srcSet(ext)} sizes={sizes} alt={alt} {...imgProps} />
    </picture>
  );
}
